import { getEnvironment } from './feature_flags';

export const READY_TO_POST_VARIANTS = {
  CONTROL: 'control',
  TREATMENT: 'treatment',
};

// TODO(GO4-<segmentation ticket>): swap this for the real assigned segment value once
// that ticket lands. Until then: staging/development show the treatment layout so it can
// be reviewed and QA'd, but production stays on control — no live user traffic sees the
// new layout until the real segmentation mechanism exists.
export const getReadyToPostVariant = user =>
  getEnvironment() === 'production' ? READY_TO_POST_VARIANTS.CONTROL : READY_TO_POST_VARIANTS.TREATMENT;
